import {
  apiClient,
  type PageEntity,
  type ShipmentOrdersListExEntity
} from '@/libs/api'
import { type ShipmentOrdersRequestQuery } from '@/libs/api/types'

export type FetchShipmentOrdersQuery = {
  tenantKey: string
  query: ShipmentOrdersRequestQuery
}

export type FetchShipmentOrdersResponse = {
  data: ShipmentOrdersListExEntity[]
  pagination: PageEntity | null
}

export const fetchShipmentOrders = async (
  { tenantKey, query }: FetchShipmentOrdersQuery,
  signal?: AbortSignal
): Promise<FetchShipmentOrdersResponse> => {
  const { data, pagination } = await apiClient
    ._tenant(tenantKey)
    .shipment_orders.$get({
      query,
      config: {
        signal
      }
    })
  return {
    data,
    pagination
  }
}
